import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import NavigationUtils from '../../../utils/navigation.utils';
import Alert from '../../shared/Alert/Alert';
import { renderIf } from '../../../utils/render.utils';
import {
  CardStatusMessage,
  CardValidStatus,
  CreditStatusMessage,
  CreditValidStatus,
} from './CardMessageConfig';
import CardStatus from '../../../constants/card.status';
import {
  ShowCreditsMessages,
  ShowAutomaticCreditsMessages,
} from '../CreditCard/CreditConfig';

export default function CardMessage({
  status,
  cardUid,
  cardNumber,
  credit = null,
  size = CardMessage.Size.LARGE,
  isHome = false,
  organization = '',
  className = '',
  lendingButtonEnabled = false,
  isPersonalizedCard = false,
  automaticLendingEnabled = false,
}) {
  const mustShowLendingMessages =
    (lendingButtonEnabled && !automaticLendingEnabled) ||
    (lendingButtonEnabled &&
      automaticLendingEnabled &&
      ShowAutomaticCreditsMessages.includes(credit?.status)) ||
    (!lendingButtonEnabled && !ShowCreditsMessages.includes(credit?.status));

  const navigate = (path, replace = false, params = {}) => {
    const baseParams = {
      organization: organization,
      organizationCode: organization,
      source: isHome
        ? NavigationUtils.Sources.HOME
        : NavigationUtils.Sources.WALLET,
      cardUid: cardUid,
      cardNumber: cardNumber,
      type:
        isHome &&
        status === CardStatus.ACTIVE &&
        lendingButtonEnabled &&
        CreditValidStatus.includes(credit?.status)
          ? 'credit'
          : 'debit',
    };

    const allParams = { ...baseParams, ...params };
    const queryString = Object.entries(allParams)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    if (isHome) {
      const url = `${path}?${queryString}`;
      DeeplinkEvent.openWebview(url);
    } else {
      NavigationUtils.navigate(path, replace, allParams);
    }
  };

  return (
    <>
      <CardStatusMessage
        status={status}
        navigate={navigate}
        className={className}
        size={size}
        isPersonalizedCard={isPersonalizedCard}
        automaticLendingEnabled={automaticLendingEnabled}
      />
      {renderIf(
        mustShowLendingMessages &&
          isHome &&
          !CardValidStatus.includes(status) &&
          credit != null,
        <CreditStatusMessage
          status={credit?.status}
          navigate={navigate}
          className={className}
          size={size}
          availableAmount={credit?.availableAmount}
          payment={credit?.payment}
          automaticLendingEnabled={automaticLendingEnabled}
        />,
      )}
    </>
  );
}
CardMessage.Size = Alert.Size;
